import { render } from "./StatTile.vue?vue&type=template&id=63f83fae&scoped=true"
import script from "./StatTile.vue?vue&type=script&lang=js"
export * from "./StatTile.vue?vue&type=script&lang=js"

import "./StatTile.vue?vue&type=style&index=0&id=63f83fae&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f83fae"]])

export default __exports__